export default 'bansPage';
